import { ReactComponent as Logo } from '../../images/TellyLogo.svg'
import { useNavigate } from 'react-router-dom'

import { routes } from 'constants/routes'
import {
  AuthGlobalStyles,
  Card,
  LogoContainer,
  Screen,
  SubmitButton,
  Subtitle,
  Title,
} from 'components/AuthForm/AuthForm.styles'

/**
 * Where the app sends people after asking for a password reset link
 * (https://app.teevee.com/account/password-reset-check-email).
 *
 * Deliberately says nothing about whether the address matched an account —
 * confirming that would let anyone use this flow to test whether a given email
 * is registered.
 */
export const PasswordResetCheckEmail: React.FC = (): JSX.Element => {
  const navigate = useNavigate()

  // window.close() only works on script-opened tabs, so hand off to the
  // mobile-app page instead — it fires the deeplink itself on a phone, and
  // tells desktop visitors how to continue. Replaces the history entry, since
  // once you're done here there's nothing to come back to.
  const handleClose = (): void => {
    navigate(routes.mobileApp.path, { replace: true })
  }

  return (
    <Screen>
      <AuthGlobalStyles />
      <Card>
        <LogoContainer>
          <Logo />
        </LogoContainer>

        <Title>Check your email</Title>
        <Subtitle>
          If we found an account for that email address, we’ve sent it a link to
          reset your password.
        </Subtitle>

        <SubmitButton type="button" onClick={handleClose}>
          Close
        </SubmitButton>
      </Card>
    </Screen>
  )
}
